import {
    EffectFade, Autoplay, Lazy, Thumbs,
} from 'swiper';

const bannerSwiperConfig = {
    modules: [Thumbs, Autoplay, EffectFade, Lazy],
    spaceBetween: 0,
    preloadImages: false,
    lazy: true,
    effect: 'fade',
    loop: true,
    autoplay: {
        delay: 8000,
        disableOnInteraction: true,
    },
};

export default bannerSwiperConfig;
